import { Select, SelectProps } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { locales } from '../../user/locale'

export function CampaignLanguageSelect(props: SelectProps) {
    const { t } = useTranslation()

    return (
        <Select
            showSearch
            optionFilterProp="label"
            options={locales.map((locale) => ({ value: locale, label: t(`locales.${locale}`) }))}
            {...props}
        />
    )
}
